module.exports = __webpack_public_path__ + "img/2045.2ec97585.svg";